import React from "react";
import "./../../App.css";
import "./Navigation.css";
import { NavLink } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import {Business, CurrentUser, UserType} from "../../types/Types";

interface Props {
   currentUser: CurrentUser;
   business: Business | undefined;
}

function Navigation(props: Props) {
    return (
      <div className={"mb-3 mt-2"}>
        <Nav variant="pills" className={"ms-2 me-2"}>
          <>
            {(props.currentUser.userType === UserType.CUSTOMER) && <NavLink className="nav-link" to="/locations">
                <b>Locations</b>
            </NavLink>}
            {(props.currentUser.userType === UserType.LOCATION_MANAGER) && <NavLink className="nav-link" to={`/business/${props.currentUser.business}`}>
                <b>Business</b>
            </NavLink>}
            {(props.currentUser.userType === UserType.LOCATION_MANAGER) && <NavLink className="nav-link" to="/menu">
              <b>Menu</b>
            </NavLink>}
            {<NavLink className="nav-link" to="/offers">
              <b>Offers</b>
            </NavLink>}
            {/*{((props.business && props.business.configuration.eventsEnabled)*/}
            {/*    || props.currentUser.userType === UserType.CUSTOMER) && <NavLink className="nav-link" to="/events">*/}
            {/*  <b>Events</b>*/}
            {/*</NavLink>}*/}
            {(props.currentUser.userType === UserType.CUSTOMER) && <NavLink className="ms-auto nav-link me-0" to="/wallet">
                <b>Wallet</b>
            </NavLink>}
            {(props.currentUser.userType === UserType.LOCATION_MANAGER) && <NavLink className="ms-auto nav-link me-0" to="/scan">
                <b>Scan</b>
            </NavLink>}
          </>
        </Nav>
      </div>
    );
}

export default Navigation;
